import {
    Modal, Button, Flex, List, Skeleton
} from 'antd';
import {
  EyeOutlined
} from '@ant-design/icons';
import React from "react";
import { useTranslation } from "react-i18next";
import DataCard from '../../components/data/DataCard';
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";


const JobHistoryView = ({vehicle, history, isViewHistoryModalVisible, lastJob, historyItem, loadingProgress, setIsViewHistoryModalVisible, clickCreateNewRequestButton, 
                         setHistoryItem}) => {
  const { t } = useTranslation();
  const { isOnline } = useOnlineStatus();

  function HistoryCardView({history, setHistoryItem, loadingProgress}) {
    // console.log(history);
    return (
            (history && history.length > 0 && loadingProgress === 100)
            ?
            <div  style={{height: 350, overflow: 'auto',}}>
              <Flex vertical>
                <List>
                  {
                    history.map(history => (
                    <List.Item key={history.id}>
                      <DataCard 
                            header={history.arrivalDate + " @ " + history.supplier}
                            extra={[<EyeOutlined style={{ fontSize: '20px' }} onClick={(e) => setHistoryItem(history)}/>]}
                      >
                        <List grid={{ gutter: 4, column: 1 }}
                              dataSource={history.items}
                              renderItem={(item) => (
                                <List.Item>
                                  {item.description}
                                </List.Item>
                              )}
                        />
                      </DataCard>                
                    </List.Item>
                  ))}
                </List>
              </Flex>
            </div>
            :
            <Skeleton active title={false} paragraph={{rows: 8}} />
           )
  }    

return (
        <Modal className="std-portal-popup dp-wrap-card-title" 
               open={isViewHistoryModalVisible && lastJob && !historyItem}
               title={t('title.history')}
               closable={true}
               keyboard={true}
               footer={ 
                        isOnline
                        ?
                        [
                          <Button type="primary" 
                                  loading={loadingProgress < 100}
                                  onClick={(e) => {
                                    setIsViewHistoryModalVisible(false); 
                                    clickCreateNewRequestButton(e);
                                  }}
                          >
                            {t('title.booking_requests')}
                          </Button>
                        ]
                        :
                        <> </>
                      }
               onCancel={() => {
                setIsViewHistoryModalVisible(false);
               }}
        >
          <HistoryCardView history={history} 
                           setHistoryItem={setHistoryItem} 
                           loadingProgress={loadingProgress}
          />
        </Modal>
       );
}

export default JobHistoryView;